<app-seat-map-mobile
  *ngIf="isMobile$|async; else desktop"
></app-seat-map-mobile>
<ng-template #desktop>
  <app-seat-map-desktop></app-seat-map-desktop>
</ng-template>
